import { render, staticRenderFns } from "./EmployeeGroupModal.vue?vue&type=template&id=5f8e56a0&scoped=true&"
import script from "./EmployeeGroupModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e56a0",
  null
  
)

export default component.exports